export const PLURAL_FORMS = ['one', 'few', 'many'] as const

export type PluralForm = (typeof PLURAL_FORMS)[number]

function polish(count: number): PluralForm {
  if (count === 1) return 'one'

  const tens = count % 100
  const units = count % 10

  if (units >= 2 && units <= 4 && (tens < 12 || tens > 14)) return 'few'

  return 'many'
}

const RULES: Record<string, (count: number) => PluralForm> = {
  en: (count) => (count === 1 ? 'one' : 'many'),
  pl: polish,
}

export function pluralFormOf(locale: string | undefined, count: number): PluralForm {
  const rule = RULES[locale ?? 'en'] ?? RULES.en

  return rule(Math.abs(count))
}
